"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var provider_1 = require("../provider");
var info_auth_1 = require("./info.auth");
var info_auth_provider_1 = require("../provider/info.auth.provider");
var InfoAuthConfig = /** @class */ (function () {
    function InfoAuthConfig() {
        // No Op
    }
    Object.defineProperty(InfoAuthConfig, "INSTANCE", {
        get: function () {
            if (InfoAuthConfig.configInstance === undefined) {
                InfoAuthConfig.configInstance = new InfoAuthConfig();
            }
            return InfoAuthConfig.configInstance;
        },
        enumerable: false,
        configurable: true
    });
    InfoAuthConfig.configure = function (config) {
        var provider = provider_1.createProvider(config);
        var infoAuthProvider = info_auth_provider_1.default(config);
        var infoAuth = info_auth_1.default.INSTANCE;
        infoAuth.setConfig(config);
        infoAuth.setAuthProvider(provider);
        infoAuth.setInfoAuthProvider(infoAuthProvider);
    };
    return InfoAuthConfig;
}());
exports.default = InfoAuthConfig;
//# sourceMappingURL=info.auth.config.js.map